/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { set, get, action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import Refinement from 'cio/app-models/conditions/refinement';
import EnvironmentService from 'cio/services/environment';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import FormCondition from 'cio/app-models/conditions/form';
import CustomFormsService from 'cio/services/custom-forms';
import AuthService from 'cio/services/auth';

interface CioConditionEditorFormArgs {
  condition: FormCondition;
  attributeNames: string[];
  changeType: () => unknown;
  onRemove: () => unknown;
  onDuplicate: () => unknown;
  canDuplicate?: boolean;
  depth?: number;
  disabled: boolean;
}

export default class CioConditionEditorForm extends Component<CioConditionEditorFormArgs> {
  @service auth!: AuthService;
  @service customForms!: CustomFormsService;
  @service environment!: EnvironmentService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  inverseOptions = [
    { value: false, label: 'has been submitted' },
    { value: true, label: 'has not been submitted' },
  ];

  @computed('args.condition.refinement', 'args.condition.filters')
  get isRefined() {
    let { refinement, filters } = this.args.condition;

    return !isNone(refinement) || filters.length > 0;
  }

  @action
  addRefinement() {
    set(this.args.condition, 'refinement', Refinement.create());
  }

  @action
  removeRefinement() {
    set(this.args.condition, 'refinement', null);
  }

  @action
  addFilter() {
    let condition = EventAttributeCondition.create({
      event: 'form_submit',
      name: '',
      operator: 'eq',
      value: '',
    });

    get(this.args.condition, 'filters').pushObject(condition);
  }

  @action
  removeFilter(filter: EventAttributeCondition) {
    get(this.args.condition, 'filters').removeObject(filter);
  }

  @action
  duplicateFilter(filter: EventAttributeCondition) {
    let duplicate = filter.duplicate();
    get(this.args.condition, 'filters').pushObject(duplicate);
  }

  constructor(owner: unknown, args: CioConditionEditorFormArgs) {
    super(owner, args);

    this.facebookLeadAds.initialize();
    this.customForms.initialize();
  }

  get hasForms() {
    return this.facebookLeadAds.enabled || this.customForms.hasConnectedOrDraftForms;
  }

  get depthClassModifier() {
    if (this.args.depth == null) {
      return null;
    }

    return `${this.args.depth % 2 === 0 ? 'even' : 'odd'}`;
  }
}
